export const HIGHLIGHT_STYLE = {
  backgroundColor: `var(--highlightColor)`,
};
